import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';

export const useContactIdentities = (contactId?: string) => {
  const queryKey = [contactsEndpoints.identities(contactId ?? '')];

  const { data, status, error, refetch } = useQuery({
    queryKey,
    queryFn: () => contactsAPI.listIdentities(contactId!),
    enabled: !!contactId,
  });

  // Removing an identity soft-deletes it (the consent trail has to survive), so
  // the API keeps returning it. A removed method is not reachable and must not
  // be displayed, counted towards messageability, or offered as a recipient.
  // Filtered here rather than in each caller: every consumer wants live rows,
  // and the ones that forgot were still rendering deleted methods.
  const identities = useMemo(() => (data ?? []).filter((identity) => !identity.deleted_at), [data]);

  return { identities, total: identities.length, status, error, refetch };
};
